import ttt from '@xingternal/ticktricktrack';

const matchEnvByHost = (map) => {
  const hostname = (global.location && global.location.hostname) || 'default';

  return map[hostname] || map.default || 'preview';
};

export const env = matchEnvByHost({
  localhost: 'development',
  'www.xing.com': 'production',
  default: 'preview',
});

export default ttt;
